import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constantes } from '../../../compartido/constantes/constantes';
import { Router } from '@angular/router';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { ConfirmationService } from 'primeng/api';
import { RequerimientoCatering, DisponibilidadDTO } from 'npm-modelado-catering';
import { RequerimientoCateringService, EstadoRequerimientoCateringService, DisponibilidadService, ConfiguracionGeneralService } from 'npm-servicios-catering';
import { RequerimientoCateringDTO, EstadoRequerimientoCatering } from 'npm-modelado-catering';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { formatDate } from '@fullcalendar/core';


@Component({
  selector: 'app-requerimiento-listar',
  templateUrl: './requerimiento-listar.component.html',
  styleUrls: ['./requerimiento-listar.component.css'],

})
export class RequerimientoListarComponent extends LoadingPage implements OnInit {

  lstEstadoRequerimiento: EstadoRequerimientoCatering[];
  lstRequerimientoCateringDTO: RequerimientoCateringDTO[];
  requerimientoCateringSeleccionado: RequerimientoCateringDTO;
  requerimientoCateringSeleccionadoCalendario: RequerimientoCateringDTO = {};
  nombrePlanificacion: string;
  requerimientoGuardar: RequerimientoCatering = {};
  fechaInicio: Date;
  idEstadoElaborada: number = 0;
  idEstadoPorRevisar: number = 0;
  idEstadoConfirmar: number = 0;
  idEstadoCancelar: number = 0;
  buscarEv: string;
  display: boolean = false;
  @ViewChild('dt') table: Table;
  optionsEstadoRequerimientos: any[];
  optionsTiposVistaPlanificacion: any[];
  mesPlanificacion: string;
  lstDisponibilidades: DisponibilidadDTO[];
  disponibilidadExcepcional: DisponibilidadDTO = {};
  numeroMesPlanificacion: number;
  ingresaComoPlanificacion: boolean = false;
  ingresaComoExcepcional: boolean = false;
  displayInfo: boolean = false;
  selectedTipoVista: string;
  showListado: boolean = true;
  options: any;
  titleDialogEvent: String = "";
  header: any;
  actividadesEvents: any[] = [];
  fechaCalendario: Date;
  colorServicioPush: string = "";
  isCheckedElaborada: boolean = true;
  isCheckedPorAprobar: boolean = true;
  isCheckedAprobada: boolean = true;
  isCheckedNoAprobada: boolean = true;
  isCheckedAceptada: boolean = true;
  isCheckedRechazada: boolean = true;
  isCheckedConfirmada: boolean = true;
  isCheckedNoConfirmada: boolean = true;
  isCheckedCancelada: boolean = true;
  disabledCampos: boolean = false;
  nombreActividadCalendarioElectoral: String = "";
  longDate: boolean = false;
  dateRangeDialogEvent: String = "";
  fechaInicioDialog: Date;
  fechaFinDialog: Date;
  muestra: boolean = false;
  direccionTooltip: string = "";
  nombreTooltip: string = "";
  direccionReferenciaEventoTooltip: string = "";
  requerimientoCateringSeleccionadoCalendarioList: RequerimientoCateringDTO[];
  hayDireccionReferencia: boolean = false;
  hayNombrePersonaRecibir: boolean = false;
  hayHoraServicioEnEvento: boolean = false;
  hayCelularPersonaRecibir: boolean = false;
  estadosServiciosParaMostrar: string[]
  position: string;
  colorEstadoElaborada = "";
  auxHoraServicioEnEvento: string = "";
  busy: Subscription;
  showCargando: boolean = true;

  selectedTipoEstado: string;
  numeroHorasConfirmar: number = 0;
  numeroHorasCancelar: number = 0;
  requerimientoCateringRecuperado: RequerimientoCatering;
  displayDetalle: boolean = false;

  detalleServicioCatering: RequerimientoCateringDTO;
  nombreEventoAux: string;

  fechaHoraInicioExcep: Date = new Date();
  fechaHoraFinExcep: Date = new Date();

  fechaAuxEvento = new Date();
  fechaAuxActual = new Date();

  constructor(private router: Router, private disponibilidadService: DisponibilidadService,
    private confirmationService: ConfirmationService, private requerimientoCateringService: RequerimientoCateringService,
    private datosSesionService: DatosSesionService, public datePipe: DatePipe,
    private estadoRequerimientoCateringService: EstadoRequerimientoCateringService,
    private configuracionGeneralCateringSerivice: ConfiguracionGeneralService
  ) {
    super(false);
  }

  ngOnInit() {

    this.colorEstadoElaborada = this._COLOR_ESTADO_ELABORADA;
    this.optionsEstadoRequerimientos = Constantes.ESTADO_REQUERIMIENTOS_CONFIRMAR_CANCELAR;
    this.optionsTiposVistaPlanificacion = Constantes.ESTADO_TIPOS_VISTAS_PLANIFICACIONES;
    this.selectedTipoVista = 'LISTADO';
    this.showListado = true;
    this.cargarEnviroment();
    this.obtenerRequerimientoCatering();
    this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
    this.ubicaNumeroMes();
    this.obtenerEstadoRequerimiento();
    this.obtenerDisponibilidadesActivas();
    this.ingresaComoExcepcional = false;
    this.ingresaComoPlanificacion = false;
    this.fechaCalendario = new Date();
    this.fechaCalendario.setMonth(Number(this.numeroMesPlanificacion));
    this.fechaCalendario.setDate(1);
    this.estadosServiciosParaMostrar = [];
    this.detalleServicioCatering = new RequerimientoCateringDTO;
  }

  verificaSiEsPlanificacion() {
    this.lstDisponibilidades.forEach(disponibilidad => {
      if (disponibilidad.tipoDisponibilidad.localeCompare("NORMAL") == 0) {

        if ((new Date(disponibilidad.fechaInicio + "T00:00:00").getMonth()) == (this.numeroMesPlanificacion - 1)) {
          this.datosSesionService.idDisponibilidadPlanificacion = disponibilidad.idDisponibilidad;
          this.datosSesionService.guardarIdDisponibilidadPlanificacion(disponibilidad.idDisponibilidad);
          this.ingresaComoPlanificacion = true;
          return;
        }
      }
    });
  }

  verificaSiEsExcepcional() {
    this.lstDisponibilidades.forEach(disponibilidad => {
      if (disponibilidad.tipoDisponibilidad.localeCompare("EXCEPCIONAL") == 0) {
        if ((new Date(disponibilidad.fechaInicio + "T00:00:00").getMonth()) == (this.numeroMesPlanificacion)) {
          this.datosSesionService.idDisponibilidadPlanificacion = disponibilidad.idDisponibilidad;
          this.datosSesionService.guardarIdDisponibilidadPlanificacion(disponibilidad.idDisponibilidad);
          this.disponibilidadExcepcional = disponibilidad;//asignamos la disponibilidad excepcional para poder utilizar luego 
          this.ingresaComoExcepcional = true;
          return;
        }
      }
    });
  }

  async agregarClick() {

    this.verificaSiEsPlanificacion();
    if (this.ingresaComoPlanificacion) {

      this.router.navigate(['/planificacion/requerimiento-crear']);
      this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
      this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
    } else {
      this.verificaSiEsExcepcional();
      if (this.ingresaComoExcepcional) {

        /*console.log(this.disponibilidadExcepcional.horaInicio.substring(0,this.disponibilidadExcepcional.horaInicio.lastIndexOf(':'))+ " hora inicio");
        console.log(this.disponibilidadExcepcional.horaFin.substring(0,this.disponibilidadExcepcional.horaFin.lastIndexOf(':'))+ " hora fin");*/


        this.fechaHoraInicioExcep = new Date();
        this.fechaHoraFinExcep = new Date();

        this.fechaHoraInicioExcep = new Date(this.disponibilidadExcepcional.fechaInicio + "T" + this.disponibilidadExcepcional.horaInicio.substring(0, this.disponibilidadExcepcional.horaInicio.lastIndexOf(':')) + ":00");
        this.fechaHoraFinExcep = new Date(this.disponibilidadExcepcional.fechaFin + "T" + this.disponibilidadExcepcional.horaFin.substring(0, this.disponibilidadExcepcional.horaFin.lastIndexOf(':')) + ":00");
        let fechaActualCompare = new Date();
        fechaActualCompare.setSeconds(0);
        fechaActualCompare.setMilliseconds(0);

        if ((fechaActualCompare > this.fechaHoraInicioExcep && fechaActualCompare < this.fechaHoraFinExcep) || (fechaActualCompare.getTime() === this.fechaHoraInicioExcep.getTime()) || (fechaActualCompare.getTime() === this.fechaHoraFinExcep.getTime())) {
          console.log("Puede ingresar");
          this.router.navigate(['/planificacion/requerimiento-crear']);
          this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
          this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
        } else {
          this.mostrarMensajeInfo("No se permite agregar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
        }


      } else {
        this.mostrarMensajeInfo("No se permite agregar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
      }
    }

  }

  public compareDate(date1: Date, date2: Date): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    let d1 = new Date(date1); let d2 = new Date(date2);

    // Check if the dates are equal
    let same = d1.getTime() === d2.getTime();
    if (same) return 0;

    // Check if the first is greater than second
    if (d1 > d2) return 1;

    // Check if the first is less than second
    if (d1 < d2) return -1;
  }

  cargarEnviroment() {
    this.requerimientoCateringService.set_constantes(Constantes);
    this.estadoRequerimientoCateringService.set_constantes(Constantes);
    this.disponibilidadService.set_constantes(Constantes);
    this.configuracionGeneralCateringSerivice.set_constantes(Constantes);
  }
  ubicaNumeroMes() {
    this.mesPlanificacion = this.datosSesionService.nombrePlanificacionActual;

    if (this.mesPlanificacion.localeCompare("ENERO") == 0) {
      this.numeroMesPlanificacion = 0;
    } else {
      if (this.mesPlanificacion.localeCompare("FEBRERO") == 0) {
        this.numeroMesPlanificacion = 1;
      } else {
        if (this.mesPlanificacion.localeCompare("MARZO") == 0) {
          this.numeroMesPlanificacion = 2;
        } else {
          if (this.mesPlanificacion.localeCompare("ABRIL") == 0) {
            this.numeroMesPlanificacion = 3;
          } else {
            if (this.mesPlanificacion.localeCompare("MAYO") == 0) {
              this.numeroMesPlanificacion = 4;
            } else {
              if (this.mesPlanificacion.localeCompare("JUNIO") == 0) {
                this.numeroMesPlanificacion = 5;
              } else {
                if (this.mesPlanificacion.localeCompare("JULIO") == 0) {
                  this.numeroMesPlanificacion = 6;
                } else {
                  if (this.mesPlanificacion.localeCompare("AGOSTO") == 0) {
                    this.numeroMesPlanificacion = 7;
                  } else {
                    if (this.mesPlanificacion.localeCompare("SEPTIEMBRE") == 0) {
                      this.numeroMesPlanificacion = 8;
                    } else {
                      if (this.mesPlanificacion.localeCompare("OCTUBRE") == 0) {
                        this.numeroMesPlanificacion = 9;
                      } else {
                        if (this.mesPlanificacion.localeCompare("NOVIEMBRE") == 0) {
                          this.numeroMesPlanificacion = 10;
                        } else {
                          if (this.mesPlanificacion.localeCompare("DICIEMBRE") == 0) {
                            this.numeroMesPlanificacion = 11;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
  }

  obtenerDisponibilidadesActivas() {
    this.busy = this.disponibilidadService.obtenerIdDisponibilidadActivaParaPlanificacion(this.datosSesionService.unidadSeleccionadaAplicativo.idUnidad).then(req => {
      if (req) {
        this.lstDisponibilidades = req;
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de obtener disponibilidades activas");
    });
  }

  obtenerRequerimientoCatering() {
    this.showCargando = true;
    this.busy = this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.datosSesionService.idPlanificacionActual).then(req => {
      if (req) {
        console.log(req);
        this.lstRequerimientoCateringDTO = req;
        if (this.lstRequerimientoCateringDTO.length == 0) {
          this.showCargando = false;
        }
        for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
          this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
          this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = Math.round(this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento * 10) / 10;
          if (i == this.lstRequerimientoCateringDTO.length - 1) {
            this.showCargando = false;
          }
        }

      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }



  eliminarClick() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      if (this.requerimientoCateringSeleccionado.idEstadoRequerimiento == this.idEstadoElaborada) {
        this.confirmationService.confirm({
          key: 'autorizacion',
          header: this._eliminarServicioCatering,
          message: '¿Está seguro que desea eliminar el servicio seleccionado?',
          accept: () => {
            this.eliminarRequerimientoCatering();
          }
        });
      } else {
        this.mostrarMensajeError("Sólo se permite eliminar un servicio en estado elaborada");
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEliminar);
    }
  }

  async copiarClick() {
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      await this.verificaSiEsPlanificacion();
      if (this.ingresaComoPlanificacion) {
        this.confirmationService.confirm({
          key: 'autorizacion',
          header: this._copiarServicioCatering,
          message: '¿Desea crear una copia en estado elaborada del registro seleccionado (Datos del evento y detalles del producto seleccionado)?',
          accept: () => {
            this.copiarRequerimientoCatering(0);
          }
        });
      } else {
        this.verificaSiEsExcepcional();
        if (this.ingresaComoExcepcional) {

          this.fechaHoraInicioExcep = new Date();
          this.fechaHoraFinExcep = new Date();

          this.fechaHoraInicioExcep = new Date(this.disponibilidadExcepcional.fechaInicio + "T" + this.disponibilidadExcepcional.horaInicio.substring(0, this.disponibilidadExcepcional.horaInicio.lastIndexOf(':')) + ":00");
          this.fechaHoraFinExcep = new Date(this.disponibilidadExcepcional.fechaFin + "T" + this.disponibilidadExcepcional.horaFin.substring(0, this.disponibilidadExcepcional.horaFin.lastIndexOf(':')) + ":00");
          let fechaActualCompare = new Date();
          fechaActualCompare.setSeconds(0);
          fechaActualCompare.setMilliseconds(0);

          if ((fechaActualCompare > this.fechaHoraInicioExcep && fechaActualCompare < this.fechaHoraFinExcep) || (fechaActualCompare.getTime() === this.fechaHoraInicioExcep.getTime()) || (fechaActualCompare.getTime() === this.fechaHoraFinExcep.getTime())) {
            this.confirmationService.confirm({
              key: 'autorizacion',
              header: this._copiarServicioCatering,
              message: 'Advertencia: Se creará una copia en estado elaborada con fecha y hora actual. Los datos del evento y detalles del producto seleccionado podrán ser modificados. ¿Desea continuar?',
              accept: () => {
                this.copiarRequerimientoCatering(1);//se envia 1 para indicar que no se va a copiar ni fechas ni horas
              }
            });
          } else {
            this.mostrarMensajeInfo("No se permite copiar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
          }


        } else {
          this.mostrarMensajeInfo("No se permite copiar requerimientos, no hay una disponibilidad activa, consulte al administrador del sistema");
        }
      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaCopiar);

    }
  }

  async copiarRequerimientoCatering(tipo) {
    this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "S");
    this.requerimientoGuardar.nombreEvento = "Copia de " + this.requerimientoCateringSeleccionado.nombreEvento;
    this.actualizarRequerimientoCateringCopiar(tipo);
  }

  actualizarRequerimientoCateringCopiar(tipo) {//crea la copia del registro    
    this.requerimientoGuardar.idRequerimientoCatering = null;
    this.requerimientoGuardar.nombreEvento = this.requerimientoGuardar.nombreEvento;
    this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this.idEstadoElaborada;
    this.requerimientoGuardar.estaActivo = "S";
    this.requerimientoGuardar.editadoAceptado = false;
    this.requerimientoGuardar.direccionReferenciaEvento = null;
    this.requerimientoGuardar.horaServicioEnEvento = null;
    this.requerimientoGuardar.responsableRecibirServicio = null;
    this.requerimientoGuardar.telefonoResponsable = null;
    this.requerimientoGuardar.observaciones = null;
    if (tipo == 1) {//si es de tipo 1 quiere decir que es excepcional y no se copia ni con fecha ni con hora el requerimiento
      this.requerimientoGuardar.fechaEvento = new Date();

      this.requerimientoGuardar.horaInicioEvento = new Date();
      let horaInicio = this.datePipe.transform(this.requerimientoGuardar.horaInicioEvento, 'HH:mm:ss');
      this.requerimientoGuardar.horaFinEvento = this.requerimientoGuardar.horaInicioEvento;
      let horaFin = this.datePipe.transform(this.requerimientoGuardar.horaFinEvento, 'HH:mm:ss');
      console.log(horaInicio + " *** " + horaFin);

      if (this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering != 0) {
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, horaInicio, horaFin, "").then(req => {
          if (req) {
            this.obtenerRequerimientoCatering();
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });
      } else {
        this.mostrarMensajeError("No se puede copiar el registro, no existe el tipo de requerimiento elaborada, comuníquese con el administrador");
      }

    } else {
      console.log(this.requerimientoGuardar.horaInicioEvento.toString() + " --- " + this.requerimientoGuardar.horaFinEvento.toString());
      var splittedInicio = this.requerimientoGuardar.horaInicioEvento.toString().split(":", 3);
      let horaInicio = new Date();
      horaInicio.setHours(parseInt(splittedInicio[0]));
      horaInicio.setMinutes(parseInt(splittedInicio[1]));
      horaInicio.setSeconds(parseInt(splittedInicio[2]));

      var splittedFin = this.requerimientoGuardar.horaFinEvento.toString().split(":", 3);
      let horaFin = new Date();
      horaFin.setHours(parseInt(splittedFin[0]));
      horaFin.setMinutes(parseInt(splittedFin[1]));
      horaFin.setSeconds(parseInt(splittedFin[2]));

      let horaI = this.datePipe.transform(horaInicio, 'HH:mm:ss');
      let horaF = this.datePipe.transform(horaFin, 'HH:mm:ss');



      if (this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering != 0) {
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, horaI, horaF, "").then(req => {
          if (req) {
            this.obtenerRequerimientoCatering();
          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });
      } else {
        this.mostrarMensajeError("No se puede copiar el registro, no existe el tipo de requerimiento elaborada, comuníquese con el administrador");
      }
    }
  }

  obtenerEstadoRequerimiento() {
    this.busy = this.estadoRequerimientoCateringService.listarEstadoRequerimientoCatering().then(estadoRequerimiento => {
      if (estadoRequerimiento) {
        this.lstEstadoRequerimiento = estadoRequerimiento;
        this.showCargando = true;
        for (var i = 0; i < this.lstEstadoRequerimiento.length; i++) {
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("ELABORADA") == 0) {
            this.idEstadoElaborada = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;
          }
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("POR APROBAR") == 0) {
            this.idEstadoPorRevisar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;
          }

          if (this.lstEstadoRequerimiento[i].nombre.localeCompare(Constantes.ESTADO_CONFIRMAR) == 0)
            this.idEstadoConfirmar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;

          if (this.lstEstadoRequerimiento[i].nombre.localeCompare(Constantes.ESTADO_CANCELAR) == 0)
            this.idEstadoCancelar = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;
        }
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar estado requerimiento, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  cargaDatosRequerimientoGuardar(idEstadoReqCatering, estaActivo) {
    this.requerimientoGuardar = new RequerimientoCatering();
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.nombreEvento.includes("...")) {
      this.requerimientoGuardar.nombreEvento = this.nombreTooltip;
    } else {
      this.requerimientoGuardar.nombreEvento = this.requerimientoCateringSeleccionado.nombreEvento;
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.direccionEvento.includes("...")) {
      this.requerimientoGuardar.direccionEvento = this.direccionTooltip;
    } else {
      this.requerimientoGuardar.direccionEvento = this.requerimientoCateringSeleccionado.direccionEvento;
    }


    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.direccionReferenciaEvento != null && this.requerimientoCateringSeleccionado.direccionReferenciaEvento.includes("...")) {

      this.requerimientoGuardar.direccionReferenciaEvento = this.direccionReferenciaEventoTooltip;
    } else {
      this.requerimientoGuardar.direccionReferenciaEvento = this.requerimientoCateringSeleccionado.direccionReferenciaEvento;
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.horaServicioEnEvento != null) {
      this.requerimientoGuardar.horaServicioEnEvento = this.requerimientoCateringSeleccionado.horaServicioEnEvento;
      this.auxHoraServicioEnEvento = this.requerimientoCateringSeleccionado.horaServicioEnEvento.toString();
    } else {
      this.auxHoraServicioEnEvento = "";
    }

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idPersonaResponsableRecibirServicio != null) {
      this.requerimientoGuardar.responsableRecibirServicio = parseInt(this.requerimientoCateringSeleccionado.idPersonaResponsableRecibirServicio);
    }


    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.telefonoResponsable != null) {
      this.requerimientoGuardar.telefonoResponsable = this.requerimientoCateringSeleccionado.telefonoResponsable;

    }

    this.requerimientoGuardar.observaciones = this.requerimientoCateringSeleccionado.observaciones;
    this.requerimientoGuardar.idRequerimientoCatering = this.requerimientoCateringSeleccionado.idRequerimientoCatering;
    this.requerimientoGuardar.estaActivo = estaActivo;
    this.requerimientoGuardar.cantidad = this.requerimientoCateringSeleccionado.cantidad;
    this.requerimientoGuardar.direccionEvento = this.requerimientoCateringSeleccionado.direccionEvento;
    this.requerimientoGuardar.estadoRequerimientoCatering = {};
    this.requerimientoGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = idEstadoReqCatering;
    this.requerimientoGuardar.fechaEvento = this.requerimientoCateringSeleccionado.fechaEvento;
    this.requerimientoGuardar.horaFinEvento = this.requerimientoCateringSeleccionado.horaFinEvento;
    this.requerimientoGuardar.horaInicioEvento = this.requerimientoCateringSeleccionado.horaInicioEvento;

    this.requerimientoGuardar.planificacionCatering = {};
    this.requerimientoGuardar.planificacionCatering.idPlanificacionCatering = this.datosSesionService.idPlanificacionActual;
    this.requerimientoGuardar.subCategoria = {};
    this.requerimientoGuardar.subCategoria.idSubCategoria = this.requerimientoCateringSeleccionado.idSubCategoria;
    this.requerimientoGuardar.usuarioCreacion = this.requerimientoCateringSeleccionado.usuarioCreacion;
    this.requerimientoGuardar.fechaCreacion = this.requerimientoCateringSeleccionado.fechaCreacion;
    this.requerimientoGuardar.disponibilidadPlanificacion = {};
    this.requerimientoGuardar.disponibilidadPlanificacion.idDisponibilidadPlanificacion = this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion;
    this.requerimientoGuardar.idUsuarioCreacion = this.requerimientoCateringSeleccionado.idUsuarioCreacion;

    //Requerimiento Catering  estado editada
    this.requerimientoGuardar.editadoAceptado = this.requerimientoCateringSeleccionado.editadoAceptado;
  }

  async eliminarRequerimientoCatering() {

    this.cargaDatosRequerimientoGuardar(this.requerimientoCateringSeleccionado.idEstadoRequerimiento, "N");

    this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(req => {
      if (req) {
        this.obtenerRequerimientoCatering();
        this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  regresarClick() {
    this.router.navigate(['/planificacion/planificacion-listar/']);
  }

  editarClick() {

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      this.datosSesionService.idDisponibilidadPlanificacion = this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion;
      this.datosSesionService.guardarIdDisponibilidadPlanificacion(this.requerimientoCateringSeleccionado.idDisponibilidadPlanificacion);
      if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ELABORADA) {
        this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
        this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
        this.router.navigate(['/planificacion/requerimiento-crear/'],
          { queryParams: { id: this.requerimientoCateringSeleccionado.idRequerimientoCatering, estado: this.disabledCampos } });

      } else if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {

        this.disabledCampos = true;
        this.datosSesionService.numeroMesPlanificacion = this.numeroMesPlanificacion;
        this.datosSesionService.guardarNumeroMesPlanificacion(this.numeroMesPlanificacion);
        this.router.navigate(['/planificacion/requerimiento-crear/'],
          { queryParams: { id: this.requerimientoCateringSeleccionado.idRequerimientoCatering, estado: this.disabledCampos } }
        );

      } else {
        this.mostrarMensajeError("Sólo se permite editar un servicio en estado elaborada ó aceptada");

      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEditar);
    }
  }

  verificarEstadoRequerimiento() {
    if (this.requerimientoCateringSeleccionado) {
      if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ELABORADA ||
        this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {
        if (this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {
          this.disabledCampos = true;
        }
      }
    }
  }

  onFechaEventoChange(value) {
    if (this.buscarEv.length == 10) {
      var dia = this.buscarEv.substring(0, this.buscarEv.indexOf('-'));
      var mes = this.buscarEv.substring(this.buscarEv.indexOf('-') + 1, this.buscarEv.indexOf('-') + 3);
      var año = this.buscarEv.substring(this.buscarEv.lastIndexOf('-') + 1);

      this.table.filter(año + "-" + mes + "-" + dia, 'fechaEvento', 'equals');
    } else {
      this.table.filter(this.buscarEv, 'fechaEvento', 'equals');
    }
  }

  confirmarCancelarClick() {

    this._obtenerTiempoConfirmarServicioCatering();
    this._obtenerTiempoCancelarServicioCatering();

    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.nombreEstadoRequerimiento == Constantes.ESTADO_ACEPTADA) {

      if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
        this.obtenerRequerimientoPorId(this.requerimientoCateringSeleccionado.idRequerimientoCatering);
        this.display = true;
      } else {
        this.mostrarMensajeInfo(this._noObjetoGrillaContinuar);
      }
    } else {
      this.mostrarMensajeInfo(this._mendajeValidacionEstadoBotonConfirmarCancelar);
    }


  }

  cancelar() {
    this.display = false;
    this.selectedTipoEstado = null;
  }

  enviarAprobacionClick() {
    this.fechaAuxActual = new Date();
    this.fechaAuxActual.setHours(0);
    this.fechaAuxActual.setMinutes(0);
    this.fechaAuxActual.setSeconds(0);    
    this.fechaAuxActual.setMilliseconds(0);
      
    this.fechaAuxEvento = new Date(this.requerimientoCateringSeleccionado.fechaEvento+ "T00:00:00");
        
    /*console.log(" "+this.fechaAuxA.toString());
    console.log(" "+this.fechaAux.toString());  

    console.log(" -- "+ this.fechaAuxA.getTime() + " fecha evento "+ this.fechaAux.getTime()+ " ++");*/

    this.verificaSiEsPlanificacion();
    if (this.requerimientoCateringSeleccionado && this.requerimientoCateringSeleccionado.idRequerimientoCatering) {
      if (this.requerimientoCateringSeleccionado.idEstadoRequerimiento == this.idEstadoElaborada) {
        if (this.fechaAuxEvento.getTime() >= this.fechaAuxActual.getTime()) {
          if (this.requerimientoCateringSeleccionado.horaInicioEvento != this.requerimientoCateringSeleccionado.horaFinEvento) {


            if (this.ingresaComoPlanificacion) {
              this.confirmarRequerimientoParaAprobacion();
            } else {
              if (this.requerimientoCateringSeleccionado.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_EXCEPCIONAL) {
                this.confirmarRequerimientoParaAprobacion();
              } else {
                this.mostrarMensajeAdvertencia(this._mensajeValidaDisponibilidadEnviarAprobacion);
              }
            }
          } else {
            this.mostrarMensajeError("No se puede enviar para aprobación la hora de inicio y fin de evento son iguales");
          }
        } else {
          this.mostrarMensajeError("No se puede enviar para aprobación, La fecha del evento debe ser igual o mayor a la fecha actual");
        }
      } else {
        this.mostrarMensajeError("Debe seleccionar un servicio en estado elaborada");

      }
    } else {
      this.mostrarMensajeInfo(this._noObjetoGrillaEnviarParaAprobar);
    }
  }


  confirmarRequerimientoParaAprobacion() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloEnviarRequerimientoCateringAprobacion,
      message: '¿Está seguro que desea enviar este registro para aprobación?',
      accept: async () => {
        this.cargaDatosRequerimientoGuardar(this.idEstadoPorRevisar, "S");

        this._actualizarRequerimientoCatering(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(),
          this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento);
      }
    });
  }

  infoClick() {
    this.displayInfo = true;
  }

  infoCerrarClick() {
    this.displayInfo = false;
  }

  cargaColor(nombreEstado) {

    if (nombreEstado.localeCompare("ELABORADA") == 0) {
      this.colorServicioPush = Constantes.COLOR_ESTADO_ELABORADA;
    } else {
      if (nombreEstado.localeCompare("POR APROBAR") == 0) {
        this.colorServicioPush = Constantes.COLOR_ESTADO_PORAPROBAR;

      } else {
        if (nombreEstado.localeCompare("APROBADA") == 0) {
          this.colorServicioPush = Constantes.COLOR_ESTADO_APROBADA;

        } else {

        }
      }
    }
  }



  async cambiaTipoVista() {
    if (this.selectedTipoVista.localeCompare("LISTADO") == 0) {
      this.buscarEv = "";
      this.muestra = false;
      this.showListado = true;

    } else {
      if (this.selectedTipoVista.localeCompare("CALENDARIO") == 0) {
        this.router.navigate(['/planificacion/requerimiento-listar-calendario']);
        this.datosSesionService.tipoVistaActual = "CALENDARIO";
        this.datosSesionService.guardarTipoVistaActual("CALENDARIO");
      }
    }
  }


  cancelarDialogActividad() {
    this.muestra = false;
  }
  /*enviarAprobacionClickCalendario() {

    this.requerimientoCateringSeleccionado = this.requerimientoCateringSeleccionadoCalendario;
    this.muestra = false;
    this.confirmPosition("left");
  }*/

  confirmPosition(position: string) {
    this.position = position;

    this.confirmationService.confirm({
      header: this._tituloEnviarRequerimientoCateringAprobacion,
      message: '¿Está seguro que desea enviar este registro para aprobación?',
      icon: 'pi pi-info-circle',
      acceptLabel: 'SI',
      accept: async () => {


        await this.cargaDatosRequerimientoGuardar(this.idEstadoPorRevisar, "S");
        this.busy = this.requerimientoCateringService.actualizar(this.requerimientoGuardar, this.requerimientoCateringSeleccionado.horaInicioEvento.toString(), this.requerimientoCateringSeleccionado.horaFinEvento.toString(), this.auxHoraServicioEnEvento).then(async req => {
          if (req) {

            this.busy = this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.datosSesionService.idPlanificacionActual).then(req => {
              if (req) {
                this.lstRequerimientoCateringDTO = req;
                for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
                  this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
                  this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = Math.round(this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento * 10) / 10;
                }

                this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;

                this.cambiaTipoVista();

                this.muestra = false;


              }
            }).catch(error => {
              this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
            });


          }
        }).catch(error => {
          this.mostrarMensajeError(error);

        });
      },
      reject: () => {

        this.muestra = true;
      },
      key: "positionDialog"
    });
  }
  cerrarDialogoReqCalendario() {
    this.muestra = false;
  }

  async guardarConfCancelClick() {

    if (this.selectedTipoEstado == Constantes.ESTADO_CONFIRMAR) {
      await this.cargaDatosRequerimientoGuardar(this.idEstadoConfirmar, Constantes.ESTA_ACTIVO_SI);
      if (this._validacionParaConfirmar()) {

        if (this._verificarTiempoConfirmar()) {
          if (this.idEstadoConfirmar > 0) {
            this.display = false;
            this._confirmarRequerimientoCateringConfirmar();
          }
        } else {
          this.mostrarMensajeInfo(this._mensajeValidacionTiempoConfirmarServicioCatering + " ( " + this.numeroHorasConfirmar + " horas antes del evento)");
          this.selectedTipoEstado = null;
        }


      }
    } else {

      await this.cargaDatosRequerimientoGuardar(this.idEstadoCancelar, Constantes.ESTA_ACTIVO_SI);

      if (this._verificarTiempoCancelar()) {
        if (this.idEstadoCancelar > 0) {
          this.display = false;

          this._confirmarRequerimientoCateringCancelar();
        }
      } else {
        this.mostrarMensajeInfo(this._mensajeValidacionTiempoCancelarServicioCatering + " ( " + this.numeroHorasCancelar + " horas antes del evento)");
        this.selectedTipoEstado = null;
      }
    }
  }

  _actualizarRequerimientoCatering(requerimientoCatering: RequerimientoCatering, horaInicioEvento: string, horaFinEvento: string, horaServicioEvento: string) {
    this.busy = this.requerimientoCateringService.actualizar(requerimientoCatering, horaInicioEvento, horaFinEvento, horaServicioEvento).then(req => {
      if (req) {
        this.obtenerRequerimientoCatering();
        this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
        this.requerimientoGuardar = null;
        this.selectedTipoEstado = null;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  _validacionParaConfirmar(): boolean {
    let resultado = true;
    let mensajeError = this._tituloMensajeValidacionGrupal;
    if (this.requerimientoGuardar && this.requerimientoGuardar.direccionReferenciaEvento == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarDireccionReferencia;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.horaServicioEnEvento == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarHoraServicio;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.responsableRecibirServicio == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarResponsable;
      resultado = false;
    }

    if (this.requerimientoGuardar && this.requerimientoGuardar.telefonoResponsable == null) {
      mensajeError += this._saltoLineaDetalle + this._mensajeValidacionConfirmarTelefono;
      resultado = false;
    }

    if (!resultado) {
      this.mostrarMensajeInfo(mensajeError);
      this.display = false;
      this.selectedTipoEstado = null;
    }

    return resultado;
  }

  obtenerRequerimientoPorId(idReq) {
    return new Promise(resolve => {
      this.requerimientoCateringService.buscarRequerimientoById(idReq).then(res => {
        if (res) {
          this.requerimientoCateringRecuperado = res;
          resolve();
        }

      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    })
  }

  _obtenerTiempoConfirmarServicioCatering() {
    this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CONFIRMAR).then(responseTipoConfig => {
      if (responseTipoConfig) {
        this.numeroHorasConfirmar = responseTipoConfig;
      }
    });
  }

  _obtenerTiempoCancelarServicioCatering() {
    this.configuracionGeneralCateringSerivice.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_CANCELAR).then(responseTipoConfig => {
      if (responseTipoConfig) {
        this.numeroHorasCancelar = responseTipoConfig;
      }
    });
  }

  _verificarTiempoConfirmar(): boolean {

    let resultado = true;

    if (this.requerimientoCateringSeleccionado.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_NORMAL) {
      console.log("es normal")
      let formatoFecha = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      let fechaEventoA = this.requerimientoGuardar.fechaEvento
      let now = moment(formatoFecha, 'YYYY-MM-DD');
      let end = moment(fechaEventoA, 'YYYY-MM-DD');
      let horas = end.diff(now, 'hours');

      if (horas < this.numeroHorasConfirmar) {
        resultado = false;
      }
    } else {
      console.log("es excepcional")
      let fechaEvento = new Date(this.requerimientoGuardar.fechaEvento + "T00:00:00")
      let fecha = new Date();
      fecha.setHours(0, 0, 0, 0);
      fechaEvento.setHours(0, 0, 0, 0);
      if (fecha > fechaEvento) {
        resultado = false;
      }
    }

    return resultado;
  }

  _verificarTiempoCancelar(): boolean {
    let resultado = true;

    if (this.requerimientoCateringSeleccionado.tipoRequerimiento == Constantes.TIPO_DISPONIBILIDAD_NORMAL) {

      let formatoFecha = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      let fechaEventoA = this.requerimientoGuardar.fechaEvento
      let now = moment(formatoFecha, 'YYYY-MM-DD');
      let end = moment(fechaEventoA, 'YYYY-MM-DD');
      let horas = end.diff(now, 'hours');
      if (horas < this.numeroHorasCancelar) {
        resultado = false;
      }

    } else {
      let fechaEvento = new Date(this.requerimientoGuardar.fechaEvento + "T00:00:00")
      let fecha = new Date();
      fecha.setHours(0, 0, 0, 0);
      fechaEvento.setHours(0, 0, 0, 0);
      if (fecha > fechaEvento) {
        resultado = false;
      }
    }

    return resultado;
  }

  _confirmarRequerimientoCateringConfirmar() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloConfirmarRequerimientoCatering,
      message: this._mensajeConfirmarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea confirmar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering(this.requerimientoGuardar, this.requerimientoGuardar.horaInicioEvento.toString(), this.requerimientoGuardar.horaFinEvento.toString(), this.auxHoraServicioEnEvento);
      }
    });
  }

  _confirmarRequerimientoCateringCancelar() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloCancelarRequerimientoCatering,
      message: this._memsajeCancelarServicioCatering + this._saltoLinea + ' ¿Está seguro que desea cancelar el servicio seleccionado?',
      accept: () => {
        this._actualizarRequerimientoCatering(this.requerimientoGuardar, this.requerimientoGuardar.horaInicioEvento.toString(), this.requerimientoGuardar.horaFinEvento.toString(), this.auxHoraServicioEnEvento);
      }
    });
  }

  verDetalleClick(event) {

    this.detalleServicioCatering = event;
    this.detalleServicioCatering.valorTotalRequerimiento = this.detalleServicioCatering.valorUnitarioSubCategoria * this.detalleServicioCatering.cantidad;
    this.detalleServicioCatering.valorTotalRequerimiento = Math.round(this.detalleServicioCatering.valorTotalRequerimiento * 10) / 10;

    this.detalleServicioCatering.valorUnitarioSubCategoria = Math.round(this.detalleServicioCatering.valorUnitarioSubCategoria * 10) / 10;

    if (this.detalleServicioCatering.nombreEvento && this.detalleServicioCatering.nombreEvento.trim().length > 45) {
      this.nombreEventoAux = this.detalleServicioCatering.nombreEvento.toString().substring(0, 45) + "...";
    } else {
      this.nombreEventoAux = this.detalleServicioCatering.nombreEvento;
    }

    if (this.detalleServicioCatering.direccionReferenciaEvento && this.detalleServicioCatering.direccionReferenciaEvento.trim().length > 45) {
      this.direccionReferenciaEventoTooltip = this.detalleServicioCatering.direccionReferenciaEvento.toString().substring(0, 45) + "...";
    } else {
      this.direccionReferenciaEventoTooltip = this.detalleServicioCatering.direccionReferenciaEvento;
    }
    this.displayDetalle = true;
  }

  cerrarClick() {
    this.displayDetalle = false;
  }
}

